module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_cx_full_red-6c318f4b94fd992ce7654f48a362db88.svg";